import { MS_INBOX_CHANGE_STATUS_PATH } from '../../constants/AppConstants';
import fetchWithTimeout from '../../util/fetchWithTimeout';
import { msInboxApiUrl, buildMsInboxAuthHeaders, requireMsApiPlatforms } from './msInboxClient';

/**
 * PUT change_status contra el microservicio inbox.
 * @param {{ status_chat: number, chats: Array<{ id: *, platform: string }> }} payload
 */
export async function changeStatusMsInbox(payload) {
  const url = msInboxApiUrl(MS_INBOX_CHANGE_STATUS_PATH);
  const headers = await buildMsInboxAuthHeaders();

  const validChats = requireMsApiPlatforms(payload?.chats, 'change_status');

  if (validChats.length === 0) {
    return null;
  }

  const response = await fetchWithTimeout(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ ...payload, chats: validChats }),
    mode: 'cors'
  });


  if (!response.ok) {
    const errorDetails = await response.json().catch(() => ({}));
    const errorMessage = errorDetails.message
      || errorDetails.error
      || errorDetails?.errors
      || `HTTP error! Status: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  const json = await response.json().catch(() => null);

  if (json && typeof json === 'object' && json.summary && typeof json.summary === 'object') {
    const total = Number(json.summary.total);
    const successful = Number(json.summary.successful);
    if (total > 0 && successful === 0) {
      const error = new Error(
        json.message || 'Microservice change_status batch failed'
      );
      error.status = response.status;
      throw error;
    }
  }

  return json;
}
